import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm500, warm300, cream, stoneTwo } from './tokens'

type Props = { l: Translation['landing']['animSection'] }

export const AnimSection: React.FC<Props> = ({ l }) => (
  <section className="grid md:grid-cols-2 min-h-[320px] overflow-hidden" style={{ background: warm900 }}>
    <div className="relative overflow-hidden">
      <img
        src="/apps/ca/img/decor/anim_bg.jpg"
        alt=""
        aria-hidden
        className="w-full h-full object-cover"
        style={{ filter: 'brightness(0.75) saturate(1.1)', animation: 'kenburns 15s ease-in-out infinite alternate, flicker 0.8s ease-in-out infinite' }}
      />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, transparent 60%, #3d2a0a 100%)' }} />
    </div>
    <div className="flex flex-col justify-center px-10 md:px-16 py-16">
      <div
        className="inline-flex items-center gap-2 text-[0.78rem] font-medium tracking-[0.1em] uppercase px-4 py-2 rounded-[2px] mb-6 w-fit animate-pulse"
        style={{ background: warm500, color: cream }}
      >
        <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ background: warm300 }} />
        {l.badge}
      </div>
      <h2
        className="text-[clamp(1.8rem,3vw,2.8rem)] font-light leading-[1.2] mb-4"
        style={{ fontFamily: serif, color: cream }}
      >
        {l.title}<br /><em className="italic" style={{ color: warm300 }}>{l.titleEm}</em>
      </h2>
      <p className="text-[0.9rem] leading-[1.75]" style={{ color: stoneTwo }}>{l.body}</p>
    </div>
  </section>
)
